import React, { ReactNode, Suspense } from 'react';
import { DynamicImportErrorBoundary } from './DynamicImportErrorBoundary';

interface SafeSuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
  errorFallback?: ReactNode;
}

/**
 * A component that combines React.Suspense with DynamicImportErrorBoundary
 * to safely handle lazy-loaded components and catch any dynamic import errors.
 */
export const SafeSuspense: React.FC<SafeSuspenseProps> = ({
  children,
  fallback = <>Loading...</>,
  errorFallback
}) => {
  return (
    <DynamicImportErrorBoundary fallback={errorFallback}>
      <Suspense fallback={fallback}>
        {children}
      </Suspense>
    </DynamicImportErrorBoundary>
  );
};